





































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import AccessControlBadgeForm from '@access-control/components/access-control-badge-form.vue';
import BpcAccessControlEventTable from '@access-control/components/tables/access-control-event-table.vue';
import { AccessControlBadge } from '@access-control/interfaces/access-control-badge';

@Component({
  components: {
    'bpc-access-control-badge-form': AccessControlBadgeForm,
    'bpc-access-control-event-table': BpcAccessControlEventTable,
    'bpc-pos-badge': BpcAccessControlEventTable,
  },
})
export default class PosSeeBadgeModal extends Vue {
  @Prop({ type: Boolean, default: false }) readonly value: boolean;
  @Prop({ type: Number, required: true }) readonly badgeId: number;

  formModel: Partial<AccessControlBadge> = {};

  get modalTitle(): string {
    return `${this.$t('global.models.access-control-badge.heading')}${
      this.formModel?.badge_number ? `: ${this.formModel.badge_number}` : ''
    }`;
  }

  get show(): boolean {
    return this.value;
  }
  set show(value) {
    this.$emit('input', value);
  }

  // mounted() {}

  onBadgeBlocked() {
    this.$emit('on-badge-blocked');
    this.onClose();
  }

  @Watch('badgeId')
  onBadgeIdChange() {
    this.formModel = {};
  }

  onClose() {
    this.$emit('close');
  }
}
